module.exports = __webpack_public_path__ + "img/youtube.a92290c0.png";